import { ICaptionsItem } from '../../types/common';
import {
  ADD_VIDEO,
  IAddVideoAction,
  ISetVideoCaptionsAction,
  ISetVideoCaptionsEmptyAction,
  IVideoItem,
  SET_VIDEO_CAPTIONS,
  SET_VIDEO_CAPTIONS_EMPTY
} from './types';

export const addVideoAction = (video: IVideoItem): IAddVideoAction => ({
  type: ADD_VIDEO,
  video
});

export const setVideoCaptionsEmpty = (
  captionsEmpty: boolean
): ISetVideoCaptionsEmptyAction => ({
  type: SET_VIDEO_CAPTIONS_EMPTY,
  captionsEmpty
});

export const setVideoCaptionsAction = (
  code: string,
  captions: ICaptionsItem[]
): ISetVideoCaptionsAction => ({
  type: SET_VIDEO_CAPTIONS,
  code,
  captions,
});
